import { render, staticRenderFns } from "./ListPlaceholder.vue?vue&type=template&id=676d8186"
import script from "./ListPlaceholder.vue?vue&type=script&lang=js"
export * from "./ListPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports